<template>
    <div id="team">
        <div class="container py-4">
            <p class="h1 text-light">The Team</p>
            <div
                class="row row-cols-1 row-cols-sm-2 row-cols-md-3 p-2 justify-content-between"
            >
                <div
                    class="col mb-4"
                    v-for="(profile, index) in profiles"
                    :key="index"
                >
                    <div class="card h-100 bg-dark text-light shadow" >
                        <img
                            :src="require(`../img/team/${profile.imgSrc}`)"
                            :alt="profile.name"
                            class="card-img-top card-img"
                        />
                        <div class="card-body text-left">
                            <h5 class="card-title text-danger"> {{profile.name}} </h5>
                            <h6 class="card-subtitle text-light"> {{profile.position}}</h6>
                            <!-- <p class="card-text text-muted">{{profile.description}}</p> -->
                        </div>
                        <div class="card-footer py-1">
                            <a
                                :href="profile.link"
                                target="_blank"
                                class="card-link text-light"
                                style="font-size: 1.25em"
                            >
                                <i class="fas fa-info-circle"></i>
                            </a>
                            <a
                                :href="`mailto:${profile.email}`"
                                target="_blank"
                                class="card-link text-light"
                                style="font-size: 1.25em"
                            >
                                <i class="far fa-envelope"></i>
                            </a>
                        </div>
                    </div>
                </div>

                
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Team",
    data() {
        return {
            profiles: [
                {
                    name: "Albert Wong",
                    imgSrc: "albert.jpeg",
                    position: "Principal Investigator / Professor of Neurosurgery",
                    description: "description",
                    link: "https://profiles.stanford.edu/albert-wong",
                    email: "ajwong@stanford.edu",
                },
                {
                    name: "Puja Gupta",
                    imgSrc: "puja.jpeg",
                    position: "Lab Manager",
                    description: "description",
                    link: "https://www.linkedin.com/in/puja-gupta-267a2833/",
                    email: "pujag@stanford.edu",
                },
                {
                    name: "Steve Skirboll",
                    imgSrc: "steve.png",
                    position: "Associate Professor Of Neurosurgery",
                    description: "description",
                    link: "https://profiles.stanford.edu/stephen-skirboll",
                    email: "pujag@stanford.edu",
                },
                {
                    name: "Anin Sayana",
                    imgSrc: "anin.jpeg",
                    position: "Student, Stanford University",
                    description: "description",
                    link: "https://www.linkedin.com/in/anin-sayana-981189bb/",
                    email: "pujag@stanford.edu",
                },
                {
                    name: "Siddharth Nath",
                    imgSrc: "sid.jpeg",
                    position: "Student, University of California, Berkeley",
                    description: "description",
                    link: "https://sidnath.web.app/",
                    email: "sidnath21@gmail.com",
                },
                {
                    name: "Avani Anne",
                    imgSrc: "person.png",
                    position: "Student, Harvey Mudd College",
                    description: "description",
                    link: "",
                    email: "",
                },
                {
                    name: "Mario Fidanza, Ph.D",
                    imgSrc: "person.png",
                    position: "Gritstone Oncology",
                    description: "description",
                    link: "",
                    email: "",
                },
                {
                    name: "Svenja-Marie Pahlke",
                    imgSrc: "person.png",
                    position: "University of Oxford",
                    description: "description",
                    link: "",
                    email: "",
                },
            ],
        };
    },
};
</script>

<style scoped>
#team {
    background-color: #23262b;
    /* background-color: #393A3C; */
}
.card-img {
    background-size: contain;
    
    

}
</style>